<template>
  <section class="content-header">
    <h1>Informe de calidad de operarios</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="label-vacia">&nbsp;</label>
              <button class="btn btn-primary btn-block" @click="cargarInforme" :disabled="generando">
                <i class="fa" :class="generando ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                {{ generando ? 'Generando...' : 'Generar PDF' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

<form id="FormInforme" method="post" target="VentanaInforme" style="display:none"></form>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Calendar from 'primevue/calendar';

export default {
  components: { Calendar },

  data() {
    const hoy = new Date();
    return {
      fechaInicio: new Date(hoy.getFullYear(), 0, 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme() {
        window.open('', 'VentanaInforme');
      this.generando = true;
      try {
        const api = new PwgsApi();

        const html = await api.post('informes/informe_calidad_operarios', {
          tipo_respuesta: 'pdf',
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin)
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        formOrigen.querySelectorAll('input').forEach(input => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = input.name;
          i.value = input.value;
          form.appendChild(i);
        });

        form.submit();
      } finally {
        this.generando = false;
      }
    }
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.label-vacia {
  display: block;
}
</style>